@switch (pdfPreviewState()) {
  @case (PdfPreviewState.loading) {
    <div class="centered-content">
      <app-loading-spinner></app-loading-spinner>
      <p style="color: black; margin-top: 10px">We're generating the preview now</p>
    </div>
  }
  @case (PdfPreviewState.loaded) {
    <ng2-pdfjs-viewer
      [pdfSrc]="pdfPreviewUrl()"
      [viewerFolder]="'assets/pdfjs'"
      [theme]="'light'"
      [showAnnotations]="true"
      [showDownload]="false"
      [showPrint]="false"
      [showToolbarLeft]="false"
      [showToolbarMiddle]="false"
      [showToolbarRight]="false"
      [showSecondaryToolbarToggle]="false"
      [zoom]="'page-width'"
      [customCSS]="pdfViewerCustomCss"
      style="width: 100%; height: 100%"
    >
    </ng2-pdfjs-viewer>
  }
  @case (PdfPreviewState.error) {
    <div class="centered-content" style="margin-bottom: 40px">
      <h2 style="color: black; margin-bottom: 0">Preview Failed</h2>
      <p style="color: black; margin-bottom: 5px;">Could not load the preview.</p>
      <button class="btn btn-primary btn-assessor" (click)="onClickRetry()">Retry</button>
    </div>
  }
}
